<template>
  <order-list :is-order-status="5"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'PartUnpaid',
  components: {
    OrderList
  }
}
</script>
